import { render } from "./ellipsis-text.vue?vue&type=template&id=0be6e685&ts=true"
import script from "./ellipsis-text.vue?vue&type=script&lang=ts"
export * from "./ellipsis-text.vue?vue&type=script&lang=ts"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__